import React from "react"

export default class VideoPlayer extends React.Component {
  render() {
    return (
      <video
        id="myVideo"
        src="video.mp4"
        autoPlay={true}
        muted={true}
        playsInline
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/VideoPlayer.js